(() => {
  const dialog = document.getElementById('SiporaLightbox');
  if (!dialog) return;
  const picture = dialog.querySelector('[data-lb-image]');
  const viewport = dialog.querySelector('.sp-lightbox-viewport');
  const error = dialog.querySelector('[data-lb-error]');
  const previous = dialog.querySelector('[data-lb-prev]');
  const next = dialog.querySelector('[data-lb-next]');
  const minus = dialog.querySelector('[data-lb-minus]');
  const plus = dialog.querySelector('[data-lb-plus]');
  let gallery = [], index = 0, opener, scale = 1, baseWidth = 0, oldOverflow = '';
  function resetZoom() {
    scale = 1;
    picture.style.width = '';
    picture.style.height = '';
    viewport.classList.remove('is-zoomed');
    viewport.scrollTop = viewport.scrollLeft = 0;
    minus.disabled = true;
    plus.disabled = !picture.complete || !picture.naturalWidth;
  }
  function render() {
    resetZoom(); error.hidden = true; picture.hidden = false;
    picture.src = gallery[index].src;
    picture.alt = gallery[index].alt || '';
    dialog.querySelector('[data-lb-count]').textContent = `${index + 1} / ${gallery.length}`;
    previous.disabled = next.disabled = gallery.length < 2;
    plus.disabled = true;
  }
  picture.addEventListener('load', () => { resetZoom(); baseWidth = picture.getBoundingClientRect().width; plus.disabled = false; });
  picture.addEventListener('error', () => { picture.hidden = true; error.hidden = false; plus.disabled = true; });
  function open(items, position, trigger) {
    gallery = items; index = position; opener = trigger;
    oldOverflow = document.body.style.overflow;
    if (!dialog.open) dialog.showModal();
    document.body.style.overflow = 'hidden';
    render(); dialog.querySelector('[data-lb-close]').focus();
  }
  function zoom(delta) {
    if (!picture.naturalWidth) return;
    scale = Math.min(4, Math.max(1, scale + delta));
    if (scale === 1) { resetZoom(); return; }
    viewport.classList.add('is-zoomed');
    picture.style.width = `${baseWidth * scale}px`;
    picture.style.height = 'auto';
    minus.disabled = false; plus.disabled = scale >= 4;
  }
  const move = delta => { index = (index + delta + gallery.length) % gallery.length; render(); };
  previous.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
  plus.addEventListener('click', () => zoom(.5)); minus.addEventListener('click', () => zoom(-.5));
  dialog.querySelector('[data-lb-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => { document.body.style.overflow = oldOverflow; if (opener?.isConnected) opener.focus(); });
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
    if (event.key === 'Tab') {
      const items = [...dialog.querySelectorAll('button:not(:disabled)')];
      if (event.shiftKey && document.activeElement === items[0]) { event.preventDefault(); items.at(-1).focus(); }
      else if (!event.shiftKey && document.activeElement === items.at(-1)) { event.preventDefault(); items[0].focus(); }
    }
  });
  document.addEventListener('click', event => {
    const enlarge = event.target.closest('[data-sp-zoom]');
    if (enlarge) { open([{src: enlarge.dataset.src, alt: enlarge.dataset.alt}], 0, enlarge); return; }
    const productTrigger = event.target.closest('modal-opener[data-modal^="#ProductModal-"]');
    if (productTrigger && productTrigger.querySelector('.product__media img')) {
      const modal = document.querySelector(productTrigger.dataset.modal);
      const images = modal ? [...modal.querySelectorAll('img[data-media-id]')] : [];
      const mediaId = productTrigger.querySelector('button')?.dataset.mediaId;
      if (!images.length) return;
      event.preventDefault(); event.stopImmediatePropagation();
      const position = Math.max(0, images.findIndex(img => img.dataset.mediaId === mediaId));
      open(images.map(img => ({src: img.srcset.split(',').at(-1).trim().split(' ')[0] || img.src, alt: img.alt})), position, productTrigger.querySelector('button'));
      return;
    }
    const color = event.target.closest('[data-card-color]');
    if (color) {
      const card = color.closest('[data-sp-card]');
      if (!card) return;
      event.preventDefault();
      card.querySelectorAll('[data-card-link]').forEach(link => link.href = color.dataset.url);
      card.querySelectorAll('[data-card-color]').forEach(link => link.removeAttribute('aria-current'));
      color.setAttribute('aria-current','true');
      const image = card.querySelector('.sp-card-photo');
      const enlarge = card.querySelector('[data-sp-zoom]');
      if (image && color.dataset.image) { image.removeAttribute('srcset'); image.src = color.dataset.image; image.alt = color.dataset.alt || ''; }
      if (enlarge && color.dataset.zoom) { enlarge.dataset.src = color.dataset.zoom; enlarge.dataset.alt = color.dataset.alt || ''; }
    }
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.sp-mobile-menu[open],.sp-menu-item details[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.sp-mobile-menu[open],.sp-menu-item details[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
  const hover = matchMedia('(hover: hover) and (pointer: fine)');
  let lens;
  document.addEventListener('pointermove', event => {
    const media = event.target.closest('.product__media') || event.target.closest('modal-opener')?.querySelector('.product__media');
    const image = media?.querySelector('img');
    const source = image?.srcset?.split(',').at(-1)?.trim().split(/\s+/);
    const maximumWidth = Number.parseInt(source?.[1]) || image?.naturalWidth || 0;
    if (!hover.matches || !image || dialog.open || maximumWidth < image.clientWidth * 1.2) { if (lens) lens.style.display = 'none'; return; }
    if (!lens) { lens = document.createElement('div'); lens.className = 'sp-lens'; lens.setAttribute('aria-hidden','true'); }
    if (lens.parentElement !== media) media.append(lens);
    const box = image.getBoundingClientRect();
    const fitted = Math.min(box.width / image.naturalWidth, box.height / image.naturalHeight);
    const rect = {width: image.naturalWidth * fitted, height: image.naturalHeight * fitted,
      left: box.left + (box.width - image.naturalWidth * fitted) / 2,
      top: box.top + (box.height - image.naturalHeight * fitted) / 2};
    const x = Math.min(rect.width, Math.max(0, event.clientX - rect.left));
    const y = Math.min(rect.height, Math.max(0, event.clientY - rect.top));
    const w = Math.min(180, rect.width), h = Math.min(180, rect.height);
    const ratio = Math.min(2.5, maximumWidth / rect.width);
    const high = image.srcset?.split(',').at(-1).trim().split(' ')[0] || image.currentSrc;
    lens.style.display = 'block'; lens.style.width = `${w}px`; lens.style.height = `${h}px`;
    const parent = media.getBoundingClientRect();
    lens.style.left = `${rect.left - parent.left + Math.max(0, Math.min(rect.width - w, x - w / 2))}px`;
    lens.style.top = `${rect.top - parent.top + Math.max(0, Math.min(rect.height - h, y - h / 2))}px`;
    lens.style.backgroundImage = `url("${high}")`;
    lens.style.backgroundSize = `${rect.width * ratio}px ${rect.height * ratio}px`;
    lens.style.backgroundPosition = `${Math.max(w - rect.width * ratio, Math.min(0, w / 2 - x * ratio))}px ${Math.max(h - rect.height * ratio, Math.min(0, h / 2 - y * ratio))}px`;
  });
  document.addEventListener('pointerout', event => { if (lens && !event.relatedTarget?.closest?.('modal-opener')) lens.style.display = 'none'; });
  function positionSupport() {
    const purchasing = [...document.querySelectorAll('.product-form__submit,.cart__checkout-button,.shopify-payment-button')];
    const nearPurchase = matchMedia('(max-width: 749px)').matches && purchasing.some(button => {
      const rect = button.getBoundingClientRect();
      return rect.width > 0 && rect.top < innerHeight && rect.bottom > 0;
    });
    document.body.classList.toggle('sp-purchase-in-view', nearPurchase);
  }
  let pending = false;
  function updateSupport() { if (pending) return; pending = true; requestAnimationFrame(() => { positionSupport(); pending = false; }); }
  document.addEventListener('scroll', updateSupport, {passive: true});
  window.addEventListener('resize', updateSupport);
  new MutationObserver(updateSupport).observe(document.getElementById('MainContent') || document.body,{childList:true,subtree:true});
  positionSupport();
})();
